import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {PropositionBetsWidgetMarketClickEvent} from "../models/proposition-bets-widget.market.click-event";
import {PROPOSITION_BETS} from "../proposition-bets-widgets.consts";

export class PropositionBetsWidgetMarketClickEventHandler extends AnalyticsEventHandler {
  type = PROPOSITION_BETS.ANALYTICS.ACTION_TYPES.onMarketClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = PropositionBetsWidgetMarketClickEvent;
  }
}
